import request from '@/utils/request'

export function getUserLists(data) {
  return request({
    url: '/admin/users',
    method: 'get',
    data
  })
}

export function getUserEventHistory(data) {
  return request({
    url: '/getUserInvitedEventDetails/'+data,
    method: 'get'
  })
}

export function getUserDataById(data) {
  return request({
    url: '/admin/usersDetails/'+data,
    method: 'get'
  })
}

export function changeUserCurrentUrl(data) {
  return request({
    url: '/admin/changeUserCurrentUrl',
    method: 'post',
		data
  })
}

export function getUserDataByIds(data) {
  return request({
    url: '/userDetails',
    method: 'POST',
    data
  })
}

export function confirmIdentifire(data) {
  return request({
    url: '/getUserEventInfoByIdNumber',
    method: 'post',
    data
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/createAdmin',
    method: 'post',
    data
  })
}

export function forgotPassword(data) {
  return request({
    url: '/forgotPassword',
    method: 'post',
    data
  })
}

export function resetPassword(data) {
  return request({
    url: '/resetPassword',
    method: 'post',
    data
  })
}


export function setLastPageVisited(data) {
  return request({
    url: 'setLastPageVisited',
    method: 'POST',
    data
  })
}

export function updateUserDetails(data) {
  return request({
    url: '/admin/updateUserDetails',
    method: 'post',
    data
  })
}

export function updatUserRole(data) {
  return request({
    url: '/admin/updatUserRole',
    method: 'post',
    data
  })
}

export function createUpdateUser(inputs) {
  return request({
    url: '/admin/user',
    method: 'post',
    data: inputs
  })
}

export function getAllTags() {
  return request({
    url: '/admin/tag',
    method: 'get'
  })
}